// @ts-nocheck
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Notification extends React.Component {
  constructor() {
    super();

    this.config = {
      position: "top-right",
      autoClose: 5000
    };
  }

  render() {
    return <ToastContainer {...this.config} />;
  }
}
